import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { PDF_ACTIONS, PdfDialogData, PdfDialogDataResult } from 'src/app/global/models/dialog/pdf-dialog-data';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent {

  constructor(
    public dialogRef: MatDialogRef<PdfViewerComponent, PdfDialogDataResult>,
    @Inject(MAT_DIALOG_DATA) public data: PdfDialogData,
    private sanitizer: DomSanitizer
  ) { }


  get url() {
    // return this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + this.data.url));
    return this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + this.data.url) as string;
  }

  close(): void {
    this.dialogRef.close({
      action: PDF_ACTIONS.OK
    });
  }

  downloadPdf() {
    const source = 'data:application/pdf;base64,' + this.data.url;
    const link = document.createElement('a');
    link.href = source;
    link.download = 'Preview_Contrato.pdf';
    link.click();
  }
}
